import * as React from "react";
import { Icon } from "sb-resp-ui";

export class CloseButton extends React.Component<{
    handler: (MouseEvent) => void
}, {}> {

    render() {
        const { handler } = this.props;
        return (
            <button
                className="rj-pulse-bet-markets__close-button"
                onClick={handler}>
                <Icon i="i-12 i-o-pulsebet-clear" />
            </button>
        )
    }
}